import {
  buttonsLabels,
  roles,
  subRoles,
  subRolesCheckbox,
} from "../../../utils/constants";
import React from "react";
import { useParams } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";
import { userHasLevel } from "../../../engine/AuthRoute";

export const InstitutionsUserForms = ({ user, isFirst }) => {
  const { user: userId } = useParams();

  const {
    info: { firstname, lastname, genre, phone, title },
    status,
    email,
  } = user;

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Prénom",
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: "Nom",
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: "Fonction",
          name: "info.title",
          watchValues: [
            subRoles.institutionDemander,
            subRoles.institutionAdmin,
            subRoles.institutionFinance,
          ],
          watchRequiredCondition: true,
          watch: "subRoles",
          value: title,
          type: "input",
          required: true,
          col: 24,
        },
        // {
        //   label: "Genre",
        //   name: "info.genre",
        //   value: genre,
        //   required: true,
        //   type: "select",
        //   selectContent: [
        //     { label: "Homme", value: "male" },
        //     { label: "Femme", value: "female" },
        //   ],
        //   col: 24,
        // },
        {
          label: "Email",
          required: true,
          name: "email",
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: "Téléphone",
          name: "info.phone",
          addonBefore: "+41",
          value: phone,
          type: "input",
          col: 24,
        },
        userId !== "new"
          ? {
              label: "Accès autorisé",
              name: "status",
              value: status,
              required: true,
              type: "select",
              selectContent: [
                { label: "Oui", value: "active" },
                { label: "Non", value: "inactive" },
              ],
              col: 24,
            }
          : null,
      ],
    },
    {
      parentLabel: "Roles",
      children: [
        {
          label: "",
          name: "subRoles",
          value: user.subRoles,
          type: "checkbox",
          itemDisabled: [],
          checkboxs: subRolesCheckbox,
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: userId === "new" ? "Créer l'utilisateur" : buttonsLabels.save,
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
